<template>
  <div class="ab-f ab-rep">
    <div class="ab-head">
      <h3>Тесты</h3>
      <span class="ab-note">запущенные {{ live.length }} · завершённые {{ done.length }}</span>
      <button type="button" class="ab-x" aria-label="закрыть" @click="$emit('close')">✕</button>
    </div>
    <div class="ab-rl">
      <div class="ab-list">
        <div class="ab-tabs">
          <button type="button" :aria-pressed="curTab === 'run'" @click="setTab('run')">идут · {{ live.length }}</button>
          <button type="button" :aria-pressed="curTab === 'done'" @click="setTab('done')">завершённые · {{ done.length }}</button>
        </div>
        <button v-for="x in list" :key="x.id" type="button" :class="{ 'ab-fin': x.finishedAt != null }" :aria-pressed="t && x.id === t.id"
                @click="pickTest(x)">
          <b>{{ x.name }}</b>
          <i>{{ labelOf(x) }} · {{ x.kind === 'prepost' ? 'до / после' : 'A/B' }} · запуск {{ dl(dayOf(x.startedAt)) }}<template v-if="x.finishedAt != null"> · финиш {{ dl(dayOf(x.finishedAt)) }}</template></i>
        </button>
        <div v-if="!list.length" class="ab-empty">{{ curTab === 'done' ? 'завершённых тестов нет' : 'идущих тестов нет' }}</div>
      </div>

      <div v-if="!t" class="ab-body"><div class="ab-empty">На этой вкладке выбирать нечего.</div></div>
      <div v-else-if="!win.before || !win.after" class="ab-body"><div class="ab-empty">{{ emptyText }}</div></div>
      <div v-else class="ab-body">
        <h4>{{ labelOf(t) }} · {{ t.kind === 'prepost' ? 'до / после' : 'A/B' }}
          <span>{{ metricName }}<template v-if="t.metric === 'reach'"> · блок {{ t.block + 1 }}</template>
            · запущен {{ dl(dayOf(t.startedAt)) }}<template v-if="t.finishedAt != null"> · завершён {{ dl(dayOf(t.finishedAt)) }}</template>
            <template v-if="t.hypothesis"> · {{ t.hypothesis }}</template></span>
        </h4>

        <!-- Лента дней: окна тянутся за края и за середину. -->
        <div ref="tl" class="ab-tl" @pointerdown="startDrag">
          <span v-for="(v, i) in perDayArr" :key="i" class="ab-day"
                :style="{ left: i * step + '%', width: Math.max(0.6, step - 0.25) + '%', height: Math.round(v / peak * 46) + 'px' }"></span>
          <span v-for="k in ['before', 'after']" :key="k" class="ab-wn" :class="k" :data-w="k"
                :style="{ left: (win[k][0] - first) * step + '%', width: (win[k][1] - win[k][0] + 1) * step + '%' }">
            <span class="ab-lb">{{ k === 'before' ? 'до' : 'после' }}</span><span class="ab-hd l"></span><span class="ab-hd r"></span>
          </span>
          <span v-for="m in marks" :key="m.text" class="ab-mk" :class="{ flip: m.x > 78, fin: m.fin }" :style="{ left: m.x + '%' }"><b>{{ m.text }}</b></span>
        </div>
        <div class="ab-tlx"><span>{{ dl(first) }}</span><span>тяните окна за края или за середину</span><span>{{ dl(last) }}</span></div>

        <div class="ab-sum">
          <span class="ab-kpi"><b>{{ show(vA) }}</b><i>до · {{ len(win.before) }} дн. · {{ nText(A) }}</i></span>
          <span class="ab-kpi"><b>{{ show(vB) }}</b><i>после · {{ len(win.after) }} дн. · {{ nText(B) }}</i></span>
          <span class="ab-kpi" :class="delta === null ? '' : delta > 0 ? 'ab-up' : delta < 0 ? 'ab-dn' : ''">
            <b>{{ delta === null ? '—' : (delta > 0 ? '+' : delta < 0 ? '−' : '') + Math.abs(delta) + unit }}</b><i>изменение</i></span>
          <span class="ab-kpi"><b>{{ A.conv }} → {{ B.conv }}</b><i>конверсий</i></span>
        </div>

        <!-- Порог guardrail проверяется по окну «после»: в прототипе он хранился и нигде не проверялся. -->
        <div v-if="guard" class="ab-guard" :class="{ bad: guard.bad }" role="status">
          <template v-if="guard.bad">Guardrail нарушен: {{ guard.text }}.</template>
          <template v-else>Guardrail в норме: {{ guard.text }}.</template>
        </div>

        <!-- R43: у конверсии номера блока нет, она по convMask, а не «до последнего блока». -->
        <div v-if="vA === 0 && vB === 0" class="ab-calc"><span class="ab-warn">В обоих окнах по нулю: цель теста,
          <template v-if="t.metric === 'reach'">доля до блока {{ t.block + 1 }}, а туда</template><template v-else>{{ metricName }}, а до неё</template>
          за эти дни не дошёл никто. Форму пути видно ниже по воронке; чтобы получить ненулевую цель,
          возьмите блок пониже в настройках теста или растяните окна.</span></div>

        <div class="ab-mix">
          <template v-for="w in [[A, 'до'], [B, 'после']]" :key="w[1]">
            <span class="ab-lb">отток, {{ w[1] }}</span>
            <div class="ab-mg">
              <i v-for="(c, k) in w[0].cells" :key="k" :class="{ 'ab-pick': k === t.block }" :style="cellStyle(c.loss)"
                 :title="'Блок ' + (k + 1) + ': ушло ' + c.gone + ' из ' + w[0].bn + ' · ' + Math.round(c.loss) + ' % · дошли ' + c.reached">{{ Math.round(c.loss) }}</i>
              <u>{{ w[0].bn }} {{ ses(w[0].bn) }}</u>
            </div>
          </template>
          <template v-for="w in [['n', 'сессии'], ['conv', 'конверсии']]" :key="w[0]">
            <template v-for="side in [[A, 'до'], [B, 'после']]" :key="side[1]">
              <span class="ab-lb">{{ w[1] }}, {{ side[1] }}</span>
              <div class="ab-bar">
                <i v-for="p in shares(side[0], w[0])" :key="p.phrase" :style="{ width: p.pct + '%', background: p.color }"
                   :title="p.phrase + ' · ' + p.v + ' · ' + Math.round(p.pct) + ' %'"><template v-if="p.pct > 11">{{ Math.round(p.pct) }}&nbsp;%</template></i>
              </div>
            </template>
          </template>
        </div>

        <div class="ab-rows">
          <div v-for="r in rows" :key="r.phrase" class="ab-row">
            <span class="ab-dt" :style="{ background: r.color }"></span>
            <span class="ab-nm">{{ r.phrase }}<u>{{ nText(r.a, r.b) }} · конверсий {{ r.a.conv }} → {{ r.b.conv }}</u></span>
            <span class="ab-pair">{{ show(r.va) }} → {{ show(r.vb) }}</span>
            <span class="ab-dl" :class="r.d === null ? '' : r.d > 0 ? 'ab-up' : r.d < 0 ? 'ab-dn' : ''">{{ r.d === null ? '—' : (r.d > 0 ? '▲ +' : r.d < 0 ? '▼ −' : '= ') + Math.abs(r.d) }}</span>
          </div>
        </div>

        <div class="ab-rfoot">
          <template v-if="t.finishedAt == null">
            <span class="ab-note">завершение убирает тест в архив вместе с этими окнами, вернуть можно оттуда же</span>
            <button type="button" class="btn ab-prim" @click="finish">завершить тест</button>
          </template>
          <template v-else>
            <span class="ab-note">тест завершён {{ dl(dayOf(t.finishedAt)) }}, окна показаны те, на которых его закрыли</span>
            <button type="button" class="btn" @click="reopen">вернуть в работу</button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { windowMetric, perDay, splitWindows, halveIfNoBefore } from '@/utils/abtest';
import { dayOf } from '@/utils/layers';
import { plural } from '@/utils/segments';

const SES = ['сессия', 'сессии', 'сессий'];
const MONTHS = ['янв', 'фев', 'мар', 'апр', 'мая', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'];
const NAMES = { conv: 'конверсия', reach: 'доля до блока', medBlock: 'медианный блок', gain: 'средний прирост' };

export default {
  name: 'AbReport',
  props: {
    tests: { type: Array, required: true },
    columns: { type: Array, required: true },         // К4[] — все столбцы, включая сегменты
    sessions: { type: Array, required: true },        // К2[] всех сессий периода
    blocks: { type: Array, required: true },
    tab: { type: String, default: 'run' },            // 'run' | 'done'
  },
  emits: ['update', 'close'],
  data() {
    return { curTab: this.tab, pickId: null, want: null, win: { before: null, after: null }, drag: null };
  },
  computed: {
    live() { return this.tests.filter(x => x.finishedAt == null); },
    done() { return this.tests.filter(x => x.finishedAt != null); },
    list() { return this.curTab === 'done' ? this.done : this.live; },
    // Выбранный тест обязан лежать на открытой вкладке; иначе берём последний с неё.
    t() {
      return this.list.find(x => x.id === this.pickId) || this.list[this.list.length - 1] || null;
    },
    // Лента и окна — по дням данных столбца теста, как дниСтолбца в прототипе, а не всего периода:
    // иначе «после» ложится на дни, где у столбца сессий уже нет.
    colSes() {
      if (!this.t) return [];
      const col = this.columns.find(k => k.key === this.t.columnKey);
      if (!col) return this.tSes;   // столбца нет в периоде — хотя бы по фразам теста
      const set = new Set(col.phrases);
      return this.sessions.filter(s => set.has(s.phrase));
    },
    range() {
      let a = Infinity, b = -Infinity;
      this.colSes.forEach(s => { if (s.day < a) a = s.day; if (s.day > b) b = s.day; });
      return isFinite(a) ? { first: a, last: b } : { first: 0, last: 0 };
    },
    first() { return this.range.first; },
    last() { return this.range.last; },
    span() { return Math.max(1, this.last - this.first + 1); },
    step() { return 100 / this.span; },
    // Фразы теста в постоянном порядке и с постоянным цветом. Цвет — по месту фразы в столбце, как в форме;
    // порядок — по сессиям за весь период, чтобы строки не прыгали, когда тянешь окна.
    phrases() {
      if (!this.t) return [];
      const col = this.columns.find(k => k.key === this.t.columnKey);
      const own = col ? col.phrases : [];
      const uniq = this.t.parts.map(p => p.phrase).filter((v, i, a) => a.indexOf(v) === i);
      const total = Object.create(null);
      this.tSes.forEach(s => { total[s.phrase] = (total[s.phrase] || 0) + 1; });
      return uniq.map((phrase, j) => {
        const i = own.indexOf(phrase);
        return { phrase, i: i >= 0 ? i : own.length + j, all: total[phrase] || 0 };
      }).sort((a, b) => b.all - a.all || a.i - b.i)
        .map(x => ({ ...x, color: 'var(--ph' + (x.i % 6) + ')' }));
    },
    tSes() {
      if (!this.t) return [];
      const set = new Set(this.t.parts.map(p => p.phrase));
      return this.sessions.filter(s => set.has(s.phrase));
    },
    perDayArr() {
      const pd = perDay(this.tSes), out = [];
      for (let d = this.first; d <= this.last; d++) out.push(pd[d] || 0);
      return out;
    },
    peak() { return Math.max(1, ...this.perDayArr); },
    marks() {
      if (!this.t) return [];
      const one = (ms, name, fin) => {
        if (ms == null) return null;
        // стоит в пределах ленты, а подписана настоящей датой: та же, что в списке и шапке
        const day = dayOf(ms), d = Math.max(this.first, Math.min(this.last, day));
        return { text: name + ' · ' + this.dl(day), x: (d - this.first + 0.5) * this.step, fin };
      };
      return [one(this.t.startedAt, 'запуск', false), one(this.t.finishedAt, 'финиш', true)].filter(Boolean);
    },
    wantDone() {
      const x = this.want && this.tests.find(y => y.id === this.want.id);
      return x ? x.finishedAt != null : null;
    },
    // Почему окон нет: данных нет вовсе, один день (не делится) или сохранённое окно вне периода.
    emptyText() {
      if (!this.colSes.length) return 'В периоде нет дней данных для окон.';
      if (this.t && this.t.windows) return 'Окна завершённого теста вне выбранного периода — расширьте период.';
      return 'В периоде один день данных — окна «до» и «после» не разделить, расширьте период.';
    },
    metricName() { return this.t ? NAMES[this.t.metric] || NAMES.conv : ''; },
    unit() { return !this.t ? '' : this.t.metric === 'medBlock' ? '' : this.t.metric === 'gain' ? ' п.п.' : ' %'; },
    A() { return this.fact(this.tSes, this.win.before); },
    B() { return this.fact(this.tSes, this.win.after); },
    vA() { return this.A.value; },
    vB() { return this.B.value; },
    delta() { return this.vA === null || this.vB === null ? null : Math.round((this.vB - this.vA) * 10) / 10; },
    rows() {
      if (!this.t) return [];
      return this.phrases.map(({ phrase, color }) => {
        const own = this.tSes.filter(s => s.phrase === phrase);
        const a = this.fact(own, this.win.before), b = this.fact(own, this.win.after);
        const d = a.value === null || b.value === null ? null : Math.round((b.value - a.value) * 10) / 10;
        return { phrase, color, a, b, va: a.value, vb: b.value, d };
      });
    },
    guard() {
      const g = this.t && this.t.guardrail;
      if (!g || g.kind === 'none' || !this.win.after) return null;
      const nb = this.blocks.length;
      const w = windowMetric(this.tSes, this.win.after, g.kind, this.t.block, nb);
      if (w.value === null) return { bad: false, text: 'в окне «после» нет сессий, проверять нечего' };
      // medBlock — номер блока с 1, порог тоже с 1; conv — проценты.
      const bad = w.value < g.value;
      return g.kind === 'medBlock'
        ? { bad, text: 'медианный блок ' + w.value + ' при пороге не хуже ' + g.value }
        : { bad, text: 'конверсия ' + w.value + ' % при пороге не ниже ' + g.value + ' %' };
    },
  },
  watch: {
    // Тест сменился (или пришли новые данные) — окна берём заново: сохранённые у завершённого, расчётные у идущего.
    t: { handler() { this.resetWin(); }, immediate: true },
    // Окна сбрасываем только когда сдвинулись границы данных, а не при любой замене массива сессий.
    first() { this.resetWin(); },
    last() { this.resetWin(); },
    // Вкладку переключаем, когда страница подтвердила сохранение (тест в tests изменился), а не при отправке.
    wantDone(v) {
      if (this.want && v === this.want.done) { this.curTab = v ? 'done' : 'run'; this.pickId = this.want.id; this.want = null; }
    },
    tab(v) { this.curTab = v; },
  },
  beforeUnmount() { this.stopDrag(); },
  methods: {
    ses: n => plural(n, SES),
    // повторный клик по выбранному тесту возвращает окна к расчётным, как в П (11176)
    pickTest(x) {
      if (this.t && this.t.id === x.id) { this.resetWin(); return; }
      this.want = null; this.pickId = x.id;
    },
    dayOf,
    dl(day) { const d = new Date(day * 864e5); return d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()]; },
    labelOf(x) { const c = this.columns.find(k => k.key === x.columnKey); return c ? c.label : x.columnKey; },
    len(w) { return w[1] - w[0] + 1; },
    // Блочные метрики считаются без сессий без блоков (reached = -1), подпись называет ту же базу.
    nText(a, b) {
      const bl = this.t && this.t.metric !== 'conv', f = x => bl ? x.bn : x.n;
      const n = f(b || a);
      return (b ? f(a) + ' → ' + f(b) : f(a)) + ' ' + plural(n, SES) + (bl ? ' с блоками' : '');
    },
    show(v) { return v === null ? '—' : v + this.unit; },
    setTab(v) { this.want = null; this.curTab = v; this.pickId = null; },
    resetWin() {
      if (!this.t || !this.colSes.length) { this.win = { before: null, after: null }; return; }
      let w = splitWindows(this.t, this.last, this.first);
      // у идущего теста окна расчётные — короткий период делим пополам; сохранённые окна завершённого не трогаем
      if (!this.t.windows) w = halveIfNoBefore(w);
      this.win = { before: w.before, after: w.after };
      if (w.before && w.after) this.apart('after');   // apart читает оба окна
    },
    // Метрика окна + состав: доли пересчитываются из абсолютов, не складываются.
    fact(list, w) {
      const nb = this.blocks.length;
      if (!w) return { n: 0, bn: 0, conv: 0, value: null, cells: [] };
      const s = list.filter(x => x.day >= w[0] && x.day <= w[1]);
      const m = windowMetric(s, w, this.t.metric, this.t.block, nb);
      // сетка оттока только по сессиям с блоками (reached = -1 не входят), конверсии и состав — по всем
      const bn = s.filter(x => x.reached >= 0).length;
      const cells = [];
      for (let k = 0; k < nb; k++) {
        const reached = s.filter(x => x.reached >= k).length;
        cells.push({ reached, gone: bn - reached, loss: bn ? (bn - reached) / bn * 100 : 0 });
      }
      return { n: s.length, bn, conv: s.filter(x => x.convMask).length, value: m.value, cells, list: s };
    },
    // Состав окна: порядок и цвет фраз те же, что в строках, в обеих полосах одинаковые.
    shares(f, field) {
      const v = Object.create(null);
      (f.list || []).forEach(s => { v[s.phrase] = (v[s.phrase] || 0) + (field === 'n' ? 1 : (s.convMask ? 1 : 0)); });
      const arr = this.phrases.map(x => ({ phrase: x.phrase, color: x.color, v: v[x.phrase] || 0 })).filter(e => e.v);
      const sum = arr.reduce((x, e) => x + e.v, 0);
      return sum ? arr.map(e => ({ ...e, pct: e.v / sum * 100 })) : [];
    },
    cellStyle(loss) {
      const s = loss < 10 ? 0 : loss < 30 ? 20 : loss < 50 ? 40 : loss < 70 ? 60 : loss < 90 ? 80 : 100;
      return { background: 'var(--seq-' + s + ')', color: 'var(--seq-ink-' + s + ')' };
    },
    // «До» и «после» не пересекаются: общий день попал бы в оба окна и сравнение считало бы часть себя с собой.
    // Тянутое окно стоит на месте, второе уступает и сохраняет длину, пока есть куда.
    apart(who) {
      const f = this.first, l = this.last;
      const cl = w => [Math.min(Math.max(w[0], f), l), Math.min(Math.max(w[1], f), l)];
      let A = cl(this.win.before), B = cl(this.win.after);
      if (l > f && B[0] <= f) B = [f + 1, Math.max(f + 1, B[1])];
      if (A[1] >= B[0]) {
        const end = Math.max(f, B[0] - 1);
        A = who === 'after' ? [Math.max(f, end - (A[1] - A[0])), end] : [Math.min(A[0], end), end];
      }
      this.win = { before: A, after: B };
    },
    startDrag(ev) {
      const win = ev.target.closest && ev.target.closest('.ab-wn');
      // завершённый тоже можно двигать для просмотра: сохранённые окна вернутся при следующем выборе
      if (!win) return;
      const k = win.dataset.w, h = ev.target.closest('.ab-hd');
      this.drag = { k, edge: h ? (h.classList.contains('l') ? 'l' : 'r') : null, x0: ev.clientX,
                    w: this.$refs.tl.clientWidth, from: this.win[k][0], to: this.win[k][1] };
      ev.preventDefault();
      document.addEventListener('pointermove', this.onMove);
      document.addEventListener('pointerup', this.stopDrag);
      document.addEventListener('pointercancel', this.stopDrag);
    },
    onMove(ev) {
      const g = this.drag;
      if (!g) return;
      const shift = Math.round((ev.clientX - g.x0) / Math.max(1, g.w / this.span));
      let a = g.from, b = g.to;
      if (g.edge === 'l') a = Math.min(b, a + shift);
      else if (g.edge === 'r') b = Math.max(a, b + shift);
      else { a += shift; b += shift; }
      // У края данных при переносе целиком сохраняем длину, иначе окно схлопнулось бы в один день.
      const n = b - a;
      if (a < this.first) { a = this.first; if (!g.edge) b = Math.min(this.last, a + n); }
      if (b > this.last) { b = this.last; if (!g.edge) a = Math.max(this.first, b - n); }
      this.win = { ...this.win, [g.k]: [Math.max(this.first, a), Math.min(this.last, b)] };
      this.apart(g.k);
    },
    stopDrag() {
      this.drag = null;
      document.removeEventListener('pointermove', this.onMove);
      document.removeEventListener('pointerup', this.stopDrag);
      document.removeEventListener('pointercancel', this.stopDrag);
    },
    // Завершение не удаление: тест уходит в архив вместе с окнами, на которых его закрыли.
    finish() {
      this.want = { id: this.t.id, done: true };
      setTimeout(() => { this.want = null; }, 8000);   // сохранение упало (страница показала alert): ждать нечего
      this.$emit('update', { ...this.t, finishedAt: Date.now(), windows: { before: [...this.win.before], after: [...this.win.after] } });
    },
    reopen() {
      this.want = { id: this.t.id, done: false };
      setTimeout(() => { this.want = null; }, 8000);   // сохранение упало (страница показала alert): ждать нечего
      this.$emit('update', { ...this.t, finishedAt: null, windows: null });
    },
  },
};
</script>

<style>
.ins-root .ab-rep .ab-rl{display:grid; grid-template-columns:212px 1fr; gap:16px;}
.ins-root .ab-list{display:flex; flex-direction:column; gap:4px; align-self:start;}
.ins-root .ab-tabs{display:flex; gap:4px; margin-bottom:6px;}
.ins-root .ab-tabs button, .ins-root .ab-list > button{border:1px solid var(--border); border-radius:9px; background:var(--surface-1);
  color:var(--text-secondary); padding:7px 9px; cursor:pointer; font:inherit; text-align:left;}
.ins-root .ab-list > button{display:grid; gap:2px;}
.ins-root .ab-tabs button{flex:1 1 auto; min-width:0; padding:5px; white-space:nowrap; font-size:11px; text-align:center; border-radius:8px;}
.ins-root .ab-tabs button[aria-pressed="true"]{border-color:var(--accent); background:var(--accent); color:var(--on-accent);}
.ins-root .ab-list > button[aria-pressed="true"]{border-color:var(--accent); background:var(--page); color:var(--text-primary);}
.ins-root .ab-list > button b{display:block; font-weight:650; font-size:12.5px; color:var(--text-primary);}
.ins-root .ab-list > button i{display:block; font-style:normal; font-size:10.5px; color:var(--text-muted);}
.ins-root .ab-list > button.ab-fin b{color:var(--text-secondary);}
.ins-root .ab-pair{white-space:nowrap; font-variant-numeric:tabular-nums;}
.ins-root .ab-rows{display:grid; gap:4px;}
.ins-root .ab-empty{color:var(--text-muted); font-size:11.5px; padding:8px 2px;}
.ins-root .ab-body{display:grid; gap:12px; min-width:0;}
.ins-root .ab-body h4{font-size:13px; font-weight:700; margin:0;} .ins-root .ab-body h4 span{font-weight:400; font-size:11.5px; color:var(--text-muted); margin-left:6px;}
.ins-root .ab-tl{position:relative; height:66px; border:1px solid var(--border); border-radius:10px; background:var(--surface-1);
  overflow:hidden; touch-action:none; user-select:none;}
.ins-root .ab-tl .ab-day{position:absolute; bottom:0; background:var(--text-muted); opacity:.45; border-radius:1px;}
.ins-root .ab-tl .ab-wn{position:absolute; top:0; bottom:0; cursor:grab; border:0 solid; border-left-width:2px; border-right-width:2px;
  box-sizing:border-box; min-width:4px;}
.ins-root .ab-tl .ab-wn.before{border-color:var(--text-muted); background:color-mix(in oklab, var(--text-muted) 18%, transparent);}
.ins-root .ab-tl .ab-wn.after{border-color:var(--accent); background:color-mix(in oklab, var(--accent) 18%, transparent);}
.ins-root .ab-tl .ab-wn .ab-lb{position:absolute; top:3px; left:5px; font-size:10px; font-weight:700; letter-spacing:.02em;
  color:var(--text-secondary); pointer-events:none;}
.ins-root .ab-tl .ab-wn.after .ab-lb{color:var(--accent);}
.ins-root .ab-tl .ab-hd{position:absolute; top:0; bottom:0; width:11px; cursor:ew-resize;}
.ins-root .ab-tl .ab-hd.l{left:-6px;} .ins-root .ab-tl .ab-hd.r{right:-6px;}
/* запуск — сплошная линия и тёмный флажок, финиш — пунктир и флажок с обводкой: две линии не спорят */
.ins-root .ab-tl .ab-mk{position:absolute; top:0; bottom:0; width:2px; background:var(--text-primary); z-index:4; pointer-events:none;}
/* флажок ниже подписей окон «до» / «после»: у запуска обычно начинается «после», на одной высоте он её закрывал */
.ins-root .ab-tl .ab-mk b{position:absolute; top:20px; left:5px; white-space:nowrap; font-size:9.5px; font-weight:700;
  color:var(--page); background:var(--text-primary); border-radius:4px; padding:1px 5px;}
.ins-root .ab-tl .ab-mk.flip b{left:auto; right:5px;}
.ins-root .ab-tl .ab-mk.fin{width:0; background:none; border-left:2px dashed var(--text-primary);}
.ins-root .ab-tl .ab-mk.fin b{background:var(--surface-1); color:var(--text-primary); box-shadow:inset 0 0 0 1px var(--text-primary);}
.ins-root .ab-tlx{display:flex; justify-content:space-between; font-size:10px; color:var(--text-muted);}
.ins-root .ab-sum{display:flex; flex-wrap:wrap; gap:18px; align-items:flex-end;}
.ins-root .ab-sum .ab-kpi{display:grid; gap:1px;}
.ins-root .ab-sum .ab-kpi b{font-size:18px; line-height:1.1; font-variant-numeric:tabular-nums; color:var(--text-primary);}
.ins-root .ab-sum .ab-kpi i{font-style:normal; font-size:10.5px; color:var(--text-muted);}
/* рост красный, падение синее — как «к родителю» в решётке, чтобы знак не менял смысл */
.ins-root .ab-sum .ab-kpi.ab-up b{color:var(--div-pos);} .ins-root .ab-sum .ab-kpi.ab-dn b{color:var(--div-neg);}
.ins-root .ab-guard{border:1px solid var(--ev-goal); border-radius:8px; padding:6px 10px; font-size:12px;}
.ins-root .ab-guard.bad{border-color:var(--cell-100); background:color-mix(in srgb, var(--cell-100) 14%, transparent); color:var(--text-primary); font-weight:600;}
.ins-root .ab-mix{display:grid; grid-template-columns:76px 1fr; gap:4px 8px; align-items:center; font-size:11px;}
.ins-root .ab-mix .ab-lb{color:var(--text-muted); text-align:right;}
.ins-root .ab-mix .ab-bar{display:flex; height:16px; border-radius:5px; overflow:hidden; background:var(--surface-1); border:1px solid var(--border);}
.ins-root .ab-mix .ab-bar i{font-style:normal; font-size:9.5px; color:#fff; text-align:center; line-height:14px; overflow:hidden; white-space:nowrap;}
.ins-root .ab-row{display:grid; grid-template-columns:10px 1fr auto auto; gap:10px; align-items:center; font-size:12px;
  border:1px solid var(--border); border-radius:9px; padding:5px 9px; background:var(--surface-1);}
.ins-root .ab-row .ab-dt{width:10px; height:10px; border-radius:50%;}
.ins-root .ab-row .ab-nm{color:var(--text-primary); font-weight:600; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;}
.ins-root .ab-row .ab-nm u{display:block; font-weight:400; text-decoration:none; font-size:10.5px; color:var(--text-muted); font-variant-numeric:tabular-nums;}
.ins-root .ab-row .ab-pair{color:var(--text-secondary);}
.ins-root .ab-row .ab-dl{font-weight:700; min-width:62px; text-align:right; font-variant-numeric:tabular-nums;}
.ins-root .ab-row .ab-dl.ab-up{color:var(--div-pos);} .ins-root .ab-row .ab-dl.ab-dn{color:var(--div-neg);}
.ins-root .ab-rfoot{display:flex; align-items:center; justify-content:space-between; gap:8px;
  border-top:1px solid var(--border); padding-top:10px;}
@media (max-width:720px){ .ins-root .ab-rep .ab-rl{grid-template-columns:1fr;} }
</style>
